module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAK0lEQVQ4T2NgGBTg/xmG/+TgUQOQDGAw7vtPFh48Bpzh1P9PDh5EBgxtAACMNGFKKx3AMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CO.png
// module id = 1114
// module chunks = 0